import {createSlice} from '@reduxjs/toolkit';
import {loadBuildings} from '../buildings/actions';
import {areasAdapter} from './adapters';
import {AreasState} from './types';

const initialState = <AreasState>areasAdapter.getInitialState();

const slice = createSlice({
  name: 'areas',
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadBuildings.fulfilled, (state, action) => {
      areasAdapter.setAll(state, action.payload.areas ?? {});
    });
  },
});

export const {reducer: areasReducer} = slice;
